import React from "react";

const FVFRThermalMethods = ({ title, description, methods }) => {
  return (
    <section className="fvfr-thermal-section">
      <div className="container">
        <div
          className="text-center mb-5"
          data-aos="fade-up"
          data-aos-once="true"
        >
          <h2>{title}</h2>
          <p>{description}</p>
        </div>

        <div className="row g-4">
          {methods.map((method, i) => (
            <div
              key={i}
              className="col-md-6"
              data-aos="fade-up"
              data-aos-delay={`${i * 100}`}
              data-aos-once="true"
            >
              <div className="fvfr-method-card">
                <p className="fvfr-method-label">{method.label}</p>
                <p className="fvfr-method-desc">{method.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FVFRThermalMethods;
